<agr-dialog
  [data]="data"
  [contentSpacing]="false"
  data-test="cropfields-overview"
  (alt)="alt()"
  (cancel)="cancel()"
  (confirm)="confirm()"
>
  <agr-notification-empty
    [isEmpty]="
      data.groupedCropFields.mainCultivations.length === 0 &&
      data.groupedCropFields.subsequentCultivations.length === 0
    "
    [emptyTitle]="'noCropFieldsTitle' | translate"
    [emptyDescription]="'noCropFieldsDescription' | translate"
  >
    <app-cropfield-data></app-cropfield-data>
  </agr-notification-empty>
</agr-dialog>
